// A cash payment deadline as the viewer's local date and time; empty when there is no deadline
export const formatDeadline = (value) => (value
  ? new Date(value).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
  : '');
